export const ORDER_STATUS_OPTIONS = [
  { text: '입금대기', value: 'PENDING' },
  { text: '입금완료', value: 'PAID' },
  { text: '준비중', value: 'PREPARING' },
  { text: '배송완료', value: 'DELIVERED' },
  { text: '취소', value: 'CANCELED' },
  { text: '환불', value: 'REFUNDED' },
];

export const ORDER_STATUS_LABEL_MAP = ORDER_STATUS_OPTIONS.reduce(
  (ac, cv) => ({ ...ac, [cv.value]: cv.text }),
  {} as Record<string, string>,
);

export const TAX_INVOICE_STATUS_LABEL: Record<TaxInvoiceItem['status'], string> = {
  ISSUED: '발급',
  CANCELED: '취소',
  REQUESTED: '요청',
};

export const TAX_INVOICE_CHARGED_TYPE_LABEL: Record<TaxInvoiceItem['charged_type'], string> = {
  RECEIPT: '영수',
  BILL: '청구',
};

export const COOKIE_ACCESS_TOKEN = 'access-token-gachicharim-admin';
